import React from "react";
import { Switch, Route } from "react-router-dom";
import { FETCH_REGIONS } from "../regions/RegionTypes";
import { useRouteData } from "../redux/useRouteData";
import { FETCH_TEAMS } from "../teams/TeamsTypes";
import { EngineersPanel } from "./EngineersPanel";
import { EngineerForm } from "./EngineerForm";

const ENGINEER_ROUTE_DATA = [
  FETCH_REGIONS,
  FETCH_TEAMS,
];

export function EngineersPage() {
  useRouteData(ENGINEER_ROUTE_DATA);

  return (
    <Switch>
      <Route path="/administration/engineers/:id" strict={true}>
        <EngineerForm />
      </Route>
      <Route exact path="/administration/engineers/" strict={true}>
        <EngineerForm />
      </Route>
      <Route path="/administration/engineers">
        <EngineersPanel />
      </Route>
    </Switch>
  );
}
